import React from 'react'
import { getHexColor, OneColorIconProps } from '../utils'

export const PauseOutlineIcon: React.FC<OneColorIconProps> = ({ className, color = 'core-gray-100', size = 20 }) => {
  const hex = getHexColor(color)

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="6" y="4" width="4" height="16" rx="1" stroke={hex} strokeWidth="2" fill="none" />
      <rect x="14" y="4" width="4" height="16" rx="1" stroke={hex} strokeWidth="2" fill="none" />
    </svg>
  )
}
